module.exports = __webpack_public_path__ + "img/ico_list_arrow_up.fa76a4f5.svg";